import { Reveal, SectionLabel } from "./Reveal";
import { ArrowRight, Zap, Layout, Crown } from "lucide-react";

const packages = [
  {
    icon: Zap,
    name: "Onepager",
    tagline: "Der schnelle, professionelle Start",
    features: ["Eine überzeugende Seite mit allem Wichtigen", "Perfekt fürs Smartphone optimiert", "Kontaktformular & Google Maps", "In 2 Wochen online"],
    note: "Ideal für Handwerker & Einzelunternehmer",
  },
  {
    icon: Layout,
    name: "Business Website",
    tagline: "Der Standard für wachsende Betriebe",
    features: ["Bis zu 6 Unterseiten (Leistungen, Team, Galerie …)", "Lokale Google-Optimierung inklusive", "Online-Terminanfrage oder Speisekarte", "Texte & Struktur komplett von mir"],
    note: "Meistgewählt von Praxen & Restaurants",
    highlight: true,
  },
  {
    icon: Crown,
    name: "Rundum-sorglos",
    tagline: "Website + laufende Betreuung",
    features: ["Alles aus Business Website", "Monatliche Pflege, Updates & Sicherheit", "Inhalte ändern? Eine E-Mail genügt", "Persönlicher Ansprechpartner, immer"],
    note: "Für alle, die sich um nichts kümmern wollen",
  },
];

export default function Services() {
  return (
    <section id="leistungen" className="py-20 md:py-32 bg-[#F8F9FA] border-y border-[#E4E4E7]">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionLabel number="02" label="Leistungen" />
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2 className="font-display font-medium text-3xl md:text-4xl lg:text-5xl tracking-tight max-w-xl">
              Drei klare Pakete. Kein Kleingedrucktes.
            </h2>
            <p className="text-[#52525B] max-w-sm leading-relaxed">
              Den genauen Preis besprechen wir im kostenlosen Erstgespräch — abgestimmt auf das,
              was dein Betrieb wirklich braucht.
            </p>
          </div>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {packages.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.12}>
              <div
                data-testid={`service-card-${i}`}
                className={`group h-full rounded-2xl p-8 flex flex-col transition-[box-shadow,border-color,transform] duration-300 hover:-translate-y-1 ${
                  p.highlight
                    ? "bg-[#0A0A0A] text-white border border-[#0A0A0A] shadow-[0_24px_60px_-24px_rgba(10,10,10,0.5)]"
                    : "bg-white border border-[#E4E4E7] hover:border-[#2563EB]/40 hover:shadow-[0_20px_50px_-24px_rgba(37,99,235,0.25)]"
                }`}
              >
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-6 ${p.highlight ? "bg-[#2563EB]" : "bg-[#EFF6FF]"}`}>
                  <p.icon className={`w-5 h-5 ${p.highlight ? "text-white" : "text-[#2563EB]"}`} aria-hidden="true" />
                </div>
                <h3 className="font-display font-semibold text-xl tracking-tight">{p.name}</h3>
                <p className={`mt-1 text-sm ${p.highlight ? "text-white/60" : "text-[#A1A1AA]"}`}>{p.tagline}</p>
                <ul className="mt-6 space-y-3 flex-1">
                  {p.features.map((f) => (
                    <li key={f} className={`text-sm leading-relaxed flex gap-2.5 ${p.highlight ? "text-white/85" : "text-[#52525B]"}`}>
                      <span className="text-[#2563EB] font-bold" aria-hidden="true">·</span>
                      {f}
                    </li>
                  ))}
                </ul>
                <p className={`mt-6 font-mono text-[11px] uppercase tracking-wider ${p.highlight ? "text-[#60A5FA]" : "text-[#2563EB]"}`}>{p.note}</p>
                <a
                  href="#kontakt"
                  data-testid={`service-cta-${i}`}
                  className={`mt-6 inline-flex items-center gap-2 text-sm font-semibold transition-colors duration-200 ${
                    p.highlight ? "text-white hover:text-[#60A5FA]" : "text-[#0A0A0A] hover:text-[#2563EB]"
                  }`}
                >
                  Unverbindlich anfragen
                  <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" />
                </a>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
